import { type FC, lazy, Suspense } from "react"

import { type StudentEmailEditorDocument } from "@forento/core/models/studentEmail"
import type { StudentEmailEditorValue } from "@forento/ui/components/StudentEmailEditor"

const SharedStudentEmailEditor = lazy(() => import("@forento/ui/components/StudentEmailEditor"))

type Props = {
	initialValue: StudentEmailEditorDocument | null
	placeholders: string[]
	primaryColor: string
	onChange(value: StudentEmailEditorValue, isUserEdit: boolean): void
	className?: string
}
const StudentEmailEditor: FC<Props> = props => (
	<Suspense
		fallback={
			<div className="border-component-border bg-component-background min-h-96 w-full animate-pulse rounded-xl border" />
		}
	>
		<SharedStudentEmailEditor {...props} uploadImage={uploadImage} />
	</Suspense>
)

/**
 * Shares the rich content image endpoint, which stores the file and answers with a CDN URL. The URL has to be
 * absolute: a student's mail client has no origin to resolve a relative path against.
 */
export async function uploadImage(file: File): Promise<{ url: string }> {
	const formData = new FormData()
	formData.set("image", file)
	const response = await fetch("/api/rich-content/image-file", { method: "POST", body: formData })
	const result: unknown = await response.json()
	if (!isRecord(result) || result.success !== 1 || !isRecord(result.file) || typeof result.file.url !== "string") {
		throw new Error("Image upload failed")
	}
	return { url: result.file.url }
}

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === "object" && value !== null
}

export default StudentEmailEditor
